import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Layout } from '../components/Layout/Layout';
import { RcQuotesStyles } from './BackOfficeVehicleQuotes.styles';
import { RiskContainer } from '../../HouseProduct/styles/HomeResultPage.styles';
import PubblicoImpiegoModalButtons from '../../PubblicoImpiegoProduct/components/PubblicoImpiegoModalButtons';
import PubblicoImpiegoModal from '../../PubblicoImpiegoProduct/components/PubblicoImpiegoModal';
import {
  addBackOfficeQuoteToCart, loadBackOfficeQuotes, removeBackOfficeQuoteFromCart, resetBackOfficeQuotes,
} from '../../../features/backofficeResults/backofficeResultsActions';
import { confirmAlert } from '../../../common/utils/alerts';
import PageLoading from '../../../common/componentsV2/elements/PageLoading';
import { getQuoteTypes } from '../../../features/utilities/utilitiesActions';
import { V2FontImport } from '../../../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../../../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import PubblicoImpiegoSummaryCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/PubblicoImpiegoSummaryCard';
import QuoteCostSummaryCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard';

function BackOfficePubblicoImpiegoQuotes() {
  const { requestToken } = useParams();
  const state = useSelector((store) => store.backofficeResults.back_office_quotes);
  const {
    loading,
    requestInfo,
    quotes,
    processingQuote,
    addingQuote,
    customer,
    risk_quotations,
  } = state;

  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  useEffect(() => {
    loadBackOfficeQuotes(requestToken);
    getQuoteTypes();

    return () => {
      resetBackOfficeQuotes();
    };
  }, [requestToken]);

  const refresh = () => loadBackOfficeQuotes(requestToken);

  if (loading) {
    return <PageLoading />;
  }

  const fetchQuotes = () => {
    loadBackOfficeQuotes(requestToken);
  };

  const selectQuotation = (quoteId) => {
    confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addBackOfficeQuoteToCart(quoteId, fetchQuotes));
  };

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeBackOfficeQuoteFromCart(quoteId, fetchQuotes));
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }

    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (risk_quotations && risk_quotations[type.id] !== undefined) {
        for (let i = 0; i < risk_quotations[type.id].length; i++) {
          const item = risk_quotations[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    return (quoteInProccessAmount + risksTotalAmount).toFixed(2);
  };

  return (
    <Layout>
      <V2FontImport />
      <RcQuotesStyles>
        <div className="resultsPage">
          <ResultOverviewRow>
            <PubblicoImpiegoSummaryCard
              customer={customer}
              insuranceRequest={requestInfo}
            />
            <QuoteCostSummaryCard
              processingQuote={processingQuote}
              quoteTypes={quoteTypes}
              riskQuotations={risk_quotations}
              getTotal={getTotal}
              rcTypeLabel={processingQuote?.product_name}
            />
          </ResultOverviewRow>
          {quotes && quotes.res_civile
            && (
              <>
                <RiskContainer className="mb-3 pb-3 result-home-third-step">
                  {quoteTypes.map((type, index) => (
                    <React.Fragment key={index}>
                      {quotes && quotes[type.id] && (
                        <PubblicoImpiegoModalButtons
                          insuranceRequest={requestInfo}
                          processingQuote={processingQuote}
                          type={type}
                          removeItemFromCart={removeItemFromCart}
                          riskQuotations={risk_quotations}
                        />
                      )}
                    </React.Fragment>
                  ))}
                </RiskContainer>
                {quoteTypes.map((type, index) => (
                  <PubblicoImpiegoModal
                    insuranceRequest={requestInfo}
                    type={type}
                    key={index}
                    addingQuote={addingQuote}
                    quotations={quotes}
                    selectQuotation={selectQuotation}
                    refresh={refresh}
                    processingQuote={processingQuote}
                  />
                ))}
              </>
            )}
        </div>
      </RcQuotesStyles>
    </Layout>
  );
}

export default BackOfficePubblicoImpiegoQuotes;
